"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchWorkspacesSaga = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../../actionCreators/createErrorAction");
var getWorkspaceRefClient_1 = require("../../../functions/utilities/ref/get/getWorkspaceRefClient");
var effects_1 = require("redux-saga/effects");
var firestore_1 = require("firebase/firestore");
var lodash_1 = require("lodash");
var description = 'patchWorkspacesSaga';
var patchWorkspacesSaga = function (_a) {
    var firestoreInstance_1, batch_1, error_1;
    var items = _a.items;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)({
                    type: 'PATCH_WORKSPACES_REQUEST',
                    description: description,
                    requestValues: {
                        items: items,
                    },
                })];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 5, , 7]);
                firestoreInstance_1 = (0, firestore_1.getFirestore)();
                batch_1 = (0, firestore_1.writeBatch)(firestoreInstance_1);
                (0, lodash_1.forEach)(items, function (workspaceReducer, workspaceId) {
                    var data = workspaceReducer.data;
                    var workspaceMutable = tslib_1.__assign({}, data);
                    var ref = (0, getWorkspaceRefClient_1.getWorkspaceRefClient)({
                        firestore: firestoreInstance_1,
                        workspaceId: workspaceId,
                    });
                    batch_1.update(ref, workspaceMutable);
                });
                return [4 /*yield*/, batch_1.commit()];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'PATCH_WORKSPACES_SUCCESS',
                        description: description,
                        requestValues: { items: items },
                        successValues: { items: items },
                    })];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                error_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                        description: description,
                        error: error_1,
                    }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
};
exports.patchWorkspacesSaga = patchWorkspacesSaga;
